module.exports = __webpack_public_path__ + "static/img/twjd-sdb1.566680c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdb1.png
// module id = 147
// module chunks = 0